import { FlowConsumerContextEnergy as FlowContext } from '../../context';

export const shouldSkipWhenNoSolarPanels = (context: FlowContext): boolean => {
  const { hasSolarPanels } = context;

  return !hasSolarPanels;
};
